module.exports = __webpack_public_path__ + "img/home-fqa-bg-mobile.b66989f4.svg";